import { render, staticRenderFns } from "./banRoleLogin.vue?vue&type=template&id=f5ff147e&"
import script from "./banRoleLogin.vue?vue&type=script&lang=js&"
export * from "./banRoleLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5ff147e')) {
      api.createRecord('f5ff147e', component.options)
    } else {
      api.reload('f5ff147e', component.options)
    }
    module.hot.accept("./banRoleLogin.vue?vue&type=template&id=f5ff147e&", function () {
      api.rerender('f5ff147e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpCustomerService/components/banRoleLogin.vue"
export default component.exports